export default __webpack_public_path__ + "static/media/slide2.d2fcb003.jpg";